// Module
var code = "<p>Triggers webhook when survey is started or submitted.</p> ";
// Exports
module.exports = code;